import minimal from "./minimal";
import monorepo from "./monorepo";

export const COMMIT_CONFIGS = { minimal, monorepo };
